module.exports = __webpack_public_path__ + "static/tfinans2-9e565da714ecb91eaa96ae858b2ee74e.png";